// Wallet-Monitor pure functions. 1:1 portiert aus V1 useWalletMonitor.js.
// - parseOpenPositions: aus ClearinghouseState die offenen Positions extrahieren
// - 60s Poll-Interval konstant

import type {
  AssetPosition,
  ClearinghouseState,
  HLPosition,
} from '@/types/wallet-monitor';

export const WALLET_POLL_INTERVAL_MS = 60_000;
export const HL_INFO_URL = 'https://api.hyperliquid.xyz/info';
export const HL_FETCH_TIMEOUT_MS = 5000;

/**
 * Filtert die offenen Positionen aus dem ClearinghouseState.
 * V1: `assetPositions.filter(p => parseFloat(p.position?.szi) !== 0)`.
 */
export function parseOpenPositions(state: ClearinghouseState | null | undefined): HLPosition[] {
  const list: AssetPosition[] = state?.assetPositions ?? [];
  const out: HLPosition[] = [];
  for (const ap of list) {
    const szi = parseFloat(ap.position?.szi ?? '0');
    if (Number.isFinite(szi) && szi !== 0) out.push(ap.position);
  }
  return out;
}

/**
 * V1: Adresse 0x… auf 10 Chars kürzen (für Logs).
 */
export function shortAddress(addr: string): string {
  return addr.length > 10 ? `${addr.slice(0, 10)}…` : addr;
}
